import { normalizeValue } from '../helpers.js';

export default {
  getVisitorId: state => {
    return state.visitorId;
  },
  getLang: state => {
    return state.lang;
  },
  getLastHttpAction: state => {
    return state.lastHttpAction;
  },
  getHasStarted: state => {
    return state.stationStartTimestamp ? true : false;
  },

  getShowLoadindicator: state => {
    return state.showLoadindicator;
  },
  getDataLoadError: state => {
    return state.dataLoadError;
  },

  getStationIntroTrack: state => {
    if (state.cmsData)
      return state.cmsData.intro_track;
  },
  getStationHeading: state => {
    if (state.cmsData)
      return state.cmsData.heading;
  },
  getStationScreenState: state => {
      return state.screenState;
  },
  getStationIntro: state => {
    if (state.cmsData)
      return state.cmsData.intro_text;
  },
  getCurrentStep: state => {
    return state.currentStep;
  },

  getCurrentVoiceover: state => {
    if (state.cmsData) {
      if (state.screenState === 'quiz')
        return state.cmsData.voiceover_1;

      else if (state.screenState === 'spectro') {
        if (state.currentStep === 1)
          return state.cmsData.voiceover_2;

        else if (state.currentStep === 2)
          return state.cmsData.voiceover_3;

        else if (state.currentStep === 3)
          return state.cmsData.voiceover_4;

      }
    }
  },
  
  getCurrentVerses: state => {
    if (state.cmsData) {
      if (state.screenState === 'quiz')
        return state.cmsData.verses_1_2;

      else if (state.screenState === 'spectro') {
        if (state.currentStep === 1)
          return state.cmsData.verses_1_2;

        else if (state.currentStep === 2)
          return state.cmsData.verses_3;

        else if (state.currentStep === 3)
          return state.cmsData.verses_4;

      }
    }
  },

  getQuizAnswerMessage: state => {
    if (state.cmsData) {
      return state.cmsData.quiz_answer_msg;
    }
  },

  getCurrentInstruction: state => {
    if (state.cmsData) {
      if (state.screenState === 'quiz')
        return state.cmsData.instruction_1;

      else if (state.screenState === 'spectro') {
        if (state.currentStep === 1)
          return state.cmsData.instruction_2;

        else if (state.currentStep === 2)
          return state.cmsData.instruction_3;

        else if (state.currentStep === 3)
          return state.cmsData.instruction_4;

      }
    }
  },

  getCurrentInfopage: state => {
    if (state.cmsData) {
      if (state.screenState === 'spectro') {
        if (state.currentStep === 2)
          return [state.cmsData.infobutton_3, state.cmsData.infobutton_3b];

        else if (state.currentStep === 3)
          return [state.cmsData.infobutton_4, null];

      }
    }
  },

  getSpectrogramInstruction: state => {
    if (state.cmsData)
      return state.cmsData.spectrogram_instruction;
  },
  getSpectrogramIntro: state => {
    if (state.cmsData)
      return state.cmsData.spectrogram_intro;
  },


  getInstruction: state => {
    if (state.cmsData)
      return state.cmsData.instruction;
  },

  getStatisticsTotals: state => {
    if (!state.cmsData) return;
    let duration = 0,
        clicks = 0;

    if (state.stationStartTimestamp && state.stationEndTimestamp) {
      duration = state.stationEndTimestamp - state.stationStartTimestamp
    }

    clicks = state.clickCount;

    const normalized = {
      score: normalizeValue(state.correctAnswered, 0, 3), 
      duration: normalizeValue(duration, 0, 600000), // 0 – 10 minutes
      activity: normalizeValue(clicks, 0, 50),
    }

    return { normalized };
  },
  
};